import {$body, $doc, $win} from '../app/globals';

const initBlock = function( $block ) {
	const $header = $block;
	const $menuButton = $header.find( '#menu-button' );
	const $menu = $header.find( '#menu' );
	const $menuLink = $header.find( '.section-header__menu-list .menu-item-has-children > a' );
	const $mobileMenuLink = $header.find( '.section-header__mobile-menu-list .menu-item-has-children > a' );
	const $mobileMenuHashLink = $menu.find( 'a[href*="#"]' ).not( $mobileMenuLink );

	function openMenu() {
		$menu.addClass( 'active' );
		$menuButton.addClass( 'active' );
		$body.addClass( 'scroll-locked' );
		$menuButton.attr( 'aria-expanded', 'true' );
		$menu.attr( 'aria-hidden', 'false' );
	}

	function closeMenu() {
		$menu.removeClass( 'active' );
		$menuButton.removeClass( 'active' );
		$body.removeClass( 'scroll-locked' );
		$menuButton.attr( 'aria-expanded', 'false' );
		$menu.attr( 'aria-hidden', 'true' );
		$menu.find( 'li.menu-item-has-children.active' ).removeClass( 'active' ).find( 'ul.sub-menu' ).removeAttr( 'style' );
	}

	$menuButton.off( 'click.header' ).on( 'click.header', function() {
		if ( $menu.hasClass( 'active' ) ) {
			closeMenu();
		} else {
			openMenu();
		}
	} );

	$doc.off( 'keydown.header' ).on( 'keydown.header', function( e ) {
		if ( e.key === 'Escape' && $menu.hasClass( 'active' ) ) {
			closeMenu();
			$menuButton.trigger( 'focus' );
		}
	} );

	$menuLink.off( 'click.header' ).on( 'click.header', ( e ) => {
		if ( ( $( e.currentTarget ).attr( 'href' ) === '#' ) || $( e.target ).hasClass( 'svg-icon' ) ) {
			e.preventDefault();
		}
	} );

	$mobileMenuLink.off( 'click.header' ).on( 'click.header', ( e ) => {
		if ( ( $( e.currentTarget ).attr( 'href' ) === '#' ) || $( e.target ).hasClass( 'svg-icon' ) ) {
			e.preventDefault();

			$( e.currentTarget ).closest( 'li' ).toggleClass( 'active' );
			$( e.currentTarget ).next( '.sub-menu' ).slideToggle( 300 );
		}
	} );

	$mobileMenuHashLink.off( 'click.header' ).on( 'click.header', ( e ) => {
		const href = $( e.currentTarget ).attr( 'href' );
		const hashIndex = href ? href.indexOf( '#' ) : -1;

		if ( hashIndex !== -1 && hashIndex < href.length - 1 && $menu.hasClass( 'active' ) ) {
			closeMenu();
		}
	} );

	function changeHeaderBg() {
		if ( $win.scrollTop() > 0 && !$header.hasClass( 'sticky' ) ) {
			$header.addClass( 'sticky' );
		} else if ( $win.scrollTop() <= 0 ) {
			$header.removeClass( 'sticky' );
		}
	}

	function updateHeaderHeightVar() {
		document.documentElement.style.setProperty( '--header-height', `${ $header[0].offsetHeight }px` );
	}

	$doc.ready( function() {
		changeHeaderBg();
		updateHeaderHeightVar();
	} );

	$win.off( 'scroll.header' ).on( 'scroll.header', function() {
		changeHeaderBg();
	} );

	$win.off( 'resize.header' ).on( 'resize.header', function() {
		updateHeaderHeightVar();
	} );
};

app.loadBlock( initBlock, 'header', '.section-header' );

if ( module.hot ) {
	module.hot.accept();
}
